import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { userApiClient, userAuthenticationClient } from '@/scopes/common/infrastructure/user'

export function useUser() {
  const queryClient = useQueryClient()
  const { isLoading, isFetching, data } = useQuery({
    queryKey: ['user'],
    queryFn: () => userAuthenticationClient.refreshUserInfo(),
    refetchOnWindowFocus: true,
    refetchOnMount: false,
    retry: false,
  })

  const logoutMutation = useMutation({
    mutationFn: userApiClient.logout,
    onSettled: async () => {
      userAuthenticationClient.invalidateUserInfo()
      await queryClient.invalidateQueries({ queryKey: ['user'] })
    },
  })

  if (!data) {
    return {
      isLoading,
      isFetching,
      isLoggedIn: false,
    }
  }

  const { isUserLoggedIn, capitalLetter, name, isSunwebCE } = data

  return {
    isLoading,
    isFetching,
    isLoggedIn: isUserLoggedIn,
    capitalLetter,
    name,
    isSunwebCE,
    logout: logoutMutation.mutate,
    isLoggingOut: logoutMutation.isPending,
  }
}
